import React from "react";
import { ToastContainer, Slide } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const ToastMessage = () => {
  return (
    <>
      <ToastContainer
        newestOnTop={false}
        pauseOnFocusLoss={false}
        theme="light"
        transition={Slide}
      />
    </>
  );
};

export default ToastMessage;
